module.exports = __webpack_public_path__ + "static/media/portfolio1 (56).4bdb7979.jpeg";